var forum;

$(function () {
  forum = {
    hash: "wh5VvViEaTGKuKDNmNnNam8jprdBhKK9e3pG4B92MawdXE5kN5aTrVT0NukMjm2r2dBVGwPbgFGWRw0A5RHuJ97amnSSHJmT3CKg39hpkDnU2tCUwtnDbZxfzvWcnTPU",
    token: $("#email-login").attr("userToken"),
    page: 1,
    finished : false,
    search: "",
    loading: false,
    typeContent: "",
    orderBy: "data",

    init: function () {

      const userName = forum.getCookie('user_name');
  
      if (userName) {
        $("#user-name-login").text(userName);
        $("#login-link").hide();
        $("#user-data-login").show();
      } else {
        $("#login-link").show();
        $("#user-data-login").hide();
      }

  
     
      $('#sign-up').on('click', function (e) {
        e.preventDefault();
        $('#form-login').hide();
        $('#form-recover').hide();
        $('#form-signup').show();
        $('#form-title').text('Cadastro');
      });

      
      
      $('#sign-in').on('click', function (e) {
        e.preventDefault();
        $('#form-signup').hide();
        $('#form-recover').hide();
        $('#form-login').show();
        $('#form-title').text('Login');
      });

      $('#forgot-password').on('click', function (e) {
        e.preventDefault();
        $('#form-signup').hide();
        $('#form-login').hide();
        $('#form-recover').show();
        $('#form-title').text('Recuperar Senha');
      });

      $('#back-to-login').on('click', function (e) {
        e.preventDefault();
        $('#form-signup').hide();
        $('#form-login').show();
        $('#form-recover').hide();
        $('#form-title').text('Login');
      });
    },

    getCookie: function(name) {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) return parts.pop().split(';').shift();
    },

    login: function() {
      let vUser = $("#email-login"),
          vPass = $("#password-login");
    
      if (!vUser.val()) { $(".msg").html("O campo usuário deve ser preenchido"); vUser.focus(); hideMessageAfterDelay(); return; }
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (!emailRegex.test(vUser.val())){
        $(".msg").html("Por favor, insira um e-mail válido");vUser.focus();hideMessageAfterDelay();return;
      }
      if (!vPass.val()) { $(".msg").html("O campo senha deve ser preenchido"); vPass.focus(); hideMessageAfterDelay(); return; }
    
      $(".msg").html('');
      $(".loading").show();
    
      $.ajax({
        dataType: "json",
        type: "POST",
        url: `/api/v1/forum/login`,
        data: { user: vUser.val(), pass: vPass.val(), hash: forum.hash },
        success: function (req) {
          $(".loading").hide();
          if (req.success) {

            document.cookie = `user_name=${req.nome}; path=/`;
            // Atualiza o nome do usuário e exibe o elemento
            $("#user-name-login").text(req.nome);
            $("#login-link").hide();
            $("#user-data-login").show();
    
            // Redireciona para a página principal
            document.location.href = `/`;
          } else {
            $(".msg").html(req.msg);
          }
        }
      });
    },
    

    logoff: function() {
      if (confirm('Confirma Logoff?')) {
        $.ajax({
          dataType: "json",
          url: `/api/v1/forum/logout`,
          success: function (req) {
            if (req.success) {
              // Remove o cookie do nome
              document.cookie = "user_name=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC;";
              $("#user-data-login").hide();
              $("#login-link").show();
              document.location.href = `/`;
            }
          }
        });
      }
    }
    ,

    register: function(){
      let vNome = $("#name-signup"),
          vUser = $("#email-signup"),
          vPass = $("#password-signup"),
          vConfirmPass = $("#confirm_password");

      if (!vNome.val()) { $(".msg").html("O campo nome deve ser preenchido"); vNome.focus(); hideMessageAfterDelay(); return; }
      if (!vUser.val()) { $(".msg").html("O campo email deve ser preenchido"); vUser.focus(); hideMessageAfterDelay(); return; }
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (!emailRegex.test(vUser.val())){
        $(".msg").html("Por favor, insira um e-mail válido");vUser.focus();hideMessageAfterDelay();return;
      }
      const password = vPass.val();
      const senhaRegex = /^(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
  
      if (!password) {
          $(".msg").html("O campo senha deve ser preenchido");
          vPass.focus();
          hideMessageAfterDelay();
          return;
      }
      if (!senhaRegex.test(password)) {
          $(".msg").html("A senha deve ter no mínimo 8 caracteres, incluindo uma letra maiúscula, um dígito e um caractere especial.");
          vPass.focus();
          hideMessageAfterDelay();
          return;
      }
      if (password !== vConfirmPass.val()) {
          $(".msg").html("As senhas não coincidem");
          vConfirmPass.focus();
          hideMessageAfterDelay();
          return;
      }

      $(".msg").html('');
      $(".loading").show();
      
      $.ajax({
        dataType: "json",
        type: "POST",
        url: `/api/v1/forum/register`,
        data: { user: vUser.val(), nome: vNome.val(), pass: vPass.val(), hash: forum.hash },
        success: function (req) {
          $(".loading").hide();
          if(req.success){
            document.location.href = `/`
          } else {
            $(".msg").html(req.msg);
          }
        }
        
      });
    },

    sendNewPassword: function() {
      let vUser = $("#email-recover");
  
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!vUser.val()) {
          $(".msg").html("O campo email deve ser preenchido");
          vUser.focus();
          hideMessageAfterDelay();
          return;
      }
      if (!emailRegex.test(vUser.val())) { 
          $(".msg").html("Por favor, insira um e-mail válido.");
          hideMessageAfterDelay();
          return;
      }
  
      $.ajax({
          type: "POST",
          dataType: "json",
          url: "/api/v1/forum/recover/",
          data: JSON.stringify({ email: vUser.val() }),
          contentType: "application/json",
          success: (response) => {
            hideMessageAfterDelay();
          
            if (response.success) {
                $(".msg").html("Um e-mail foi enviado com instruções para redefinir sua senha.").css("color", "green").show();
            } else {
                $(".msg").html(response.msg).css("color", "red").show(); 
            }
        },
        error: (error) => {
            hideMessageAfterDelay();
            $(".msg").html("Erro ao enviar instruções. Tente novamente mais tarde.").css("color", "red").show();
        }
        });
    },
  
    handleCredentialResponse: function (response) {
   
      const data = jwt_decode(response.credential);
      let vUser = data.email;
      let vSub = data.sub;
      let vNome = data.name;
      let vImg = data.picture;
  
      $.ajax({
          dataType: "json",
          type: "POST",
          url: `/api/v1/forum/google_login`,
          data: {
              hash: forum.hash,
              email: vUser, 
              verificacao: vSub,
              nome: vNome,
              imagem: vImg
          },
          success: function (req) {
              if (req.success) {
                  document.location.href = `/`;
              } else {
                  $(".msg").html(req.msg);
              }
          },
          error: function (jqXHR, textStatus, errorThrown) {
              console.error("Erro:", errorThrown);
              $(".msg").html("Erro ao realizar login com Google.");
          }
      });
  },
  
  googleLogin: function () {
    const script = document.createElement('script');
    script.src = "https://accounts.google.com/gsi/client";
    script.async = true;
    script.defer = true;
    script.onload = () => {
        google.accounts.id.initialize({
            client_id: "93782201586-m4a0dvor1m0me4ngl0q3ks5eu5sk2ooi.apps.googleusercontent.com",
            callback: forum.handleCredentialResponse,
            auto_select: false,
            cancel_on_tap_outside: false,
            ux_mode: "popup"
        });

        google.accounts.id.renderButton(
            $("#buttonLogin")[0], {
                theme: "filled_blue", 
                size: "large", 
                type: "standard",
                shape: "pill",
                text: "signin_with",
                logo_alignment: "left",
            }
        );

        google.accounts.id.renderButton(
            $("#buttonRegister")[0], {
                theme: "filled_blue", 
                size: "large", 
                type: "standard",
                shape: "pill",
                text: "signup_with",
                logo_alignment: "left"
            }
        );

        google.accounts.id.prompt((notification) => {
            if (notification.isNotDisplayed() || notification.isSkippedMoment()) {
            }
        });
    };

    document.head.appendChild(script);
  }
  }
  
  function hideMessageAfterDelay() {
    setTimeout(() => {
        $(".msg").html(''); 
    }, 5000);
  };
  forum.init();
  $("#form-login #btnSend").click(forum.login)
  $("#form-login #email-login, #form-login #password-login").on('keypress',function(e) {
    if(e.which == 13) forum.login();
  });

  $("#form-signup #btnSend-signup").click(forum.register)
  $("#form-signup #name-signup, #form-signup #email-signup, #form-signup #password-signup, #form-signup #confirm_password").on('keypress',function(e) {
    if(e.which == 13) forum.register();
  });

  $("#btn-logoff-login").click(forum.logoff);
  $("#form-login #btnSend").click(forum.login);


  $("#form-recover #buttonSendRecover").click(forum.sendNewPassword)
  $("#form-recover #email-recover").on('keypress', function(e) {
    if (e.which == 13) {
        e.preventDefault();
        forum.sendNewPassword();
    }
  });
  forum.googleLogin();
});
